<template>
    <div class="o-inc-dec__row">
        <label class="o-inc-dec__label">
            <strong>{{title}}</strong>
            <small>{{subtitle}}</small>
        </label>

        <div class="o-inc-dec__controls">
            <button
                class="o-inc-dec__dec is-rounded"
                data-type="-"
                type="button"
                :disabled="min !== undefined && (value == min)"
                @click="decrease"
            >&ndash;</button>
            <input
                class="form-control readonly-normal"
                readonly
                type="text"
                :name="name"
                :value="value"
                :required="required">
            <button
                class="o-inc-dec__inc is-rounded"
                data-type="+"
                type="button"
                @click="increase"
                :disabled="max !== undefined && (value == max)"
            >&#43;</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0
        },
        min: Number,
        max: Number,
        name: String,
        title: String,
        subtitle: String,
        required: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        increase() {
            if (this.value < this.max) {
                this.$emit('input', this.value + 1)
            }
        },
        decrease() {
            if (this.value > this.min) {
                this.$emit('input', this.value - 1)
            }
        }
    }
}
</script>